import { jsx as _jsx } from "react/jsx-runtime";
import DOMPurify from 'dompurify';
export const htmlParser = (input)=>{
    if (!input) {
        return input;
    }
    const sanitizedInput = DOMPurify.sanitize(input);
    return /*#__PURE__*/ _jsx("div", {
        dangerouslySetInnerHTML: {
            __html: sanitizedInput
        },
        className: "d-inline-block"
    });
};
